import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {EndpointService} from "./endpoint.service";
import { BaseResponse } from "../responses/BaseResponse";
import { UpdateDynamicAttributeRequest } from "../requests/UpdateDynamicAttributeRequest";

@Injectable({providedIn: 'root'})
export class SubscriptionService {
  constructor(private http: HttpClient) {
  }

  updateSubscriptionDynamicAttribute(subscriptionId: number, userId: string, request: UpdateDynamicAttributeRequest) {
    return this.http.put<BaseResponse>(
      EndpointService.updateSubscriptionDynamicAttribute(userId, subscriptionId), 
      request
    );
  }
}
